import React from 'react';
import './SideBar.css'
import logo from "../../../Assets/logo_blueText.svg"
import admin from "../../../Assets/icons/admin_panel_settings.svg"
import teacher from "../../../Assets/icons/book.svg"
import student from "../../../Assets/icons/school.svg"
import course from "../../../Assets/icons/source.svg"
import department from "../../../Assets/icons/dashboard_customize.svg"
import constant from "../../../Assets/icons/lock_outline.svg"
import translation from "../../../Assets/icons/g_translate.svg"
import online from "../../../Assets/icons/miscellaneous_services.svg"
import ManagementList from "../ManagementList/ManagementList";
import logo_gray from "../../../Assets/logo_gray.svg"
import call from "../../../Assets/icons/call.svg"
import constant_active from "../../../Assets/icons_active/lock_outline_active.svg"
import department_active from "../../../Assets/icons_active/dashboard_active.svg"
import admin_active from "../../../Assets/icons_active/admin_active.svg"
import student_active from '../../../Assets/icons_active/school_active.svg'
import teacher_active from '../../../Assets/icons_active/book_active.svg'
import course_active from '../../../Assets/icons_active/course_active.svg'

//constant_active пока что филлер, потом по мере надобности будем менять

const SideBar = () => {
    const users = [
        {name: "Admins", icon: admin, active: admin_active},
        {name: "Teachers", icon: teacher, active: teacher_active},
        {name: "Students", icon: student, active: student_active},
    ]
    const contents = [
        {name: "Courses", icon: course, active: course_active},
    ]
    const systems = [
        {name: "Departments", icon: department, active: department_active},
        {name: "Constants", icon: constant, active: constant_active},
        {name: "Translations", icon: translation, active: constant_active},
        {name: "Online services", icon: online, active: constant_active},
    ]
    return (
        <div>
            <nav className={"navBar"}>
                <div className={"navBar__content"}>
                    <div className={"logo__img"}>
                        <img src={logo} alt={"companyLogo"}/>
                    </div>
                    <div className={"navBar__body"}>
                        <p className={"companyName"}>
                            Management center
                        </p>
                        <div className={"navigation"}>
                            <div className={"nav_links"}>
                                <ManagementList users={users} title={"User"}/>
                                <ManagementList users={contents} title={"Content"}/>
                                <ManagementList users={systems} title={"System"}/>
                            </div>
                            <div className={"footer"}>
                                <div className={"logo__name"}>
                                    <img src={logo_gray} alt={"logo"}/>
                                    <p>Platform for Effective Learning Management</p>
                                </div>
                                <div className={"call"}>
                                    <img src={call} alt={"call"}/>
                                    <p>Help center</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default SideBar;